<template>
    <div class="reservation">
      <loading v-if="loading"/>
      <section id="reservation" class="">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 text-center">
              <h2 class="section-heading text-uppercase">Reservation</h2>
              <h3 class="section-subheading text-muted">預約停車</h3>
            </div>
          </div> 



          <!-- 選擇日期 -->
          <div class="row" v-if="mode == 'date'">
            <div class="col-lg-12 text-center reservation-plate-text">
              請選擇您欲預約的日期
            </div>
            <div class="reservation-date" :class="{'shake': shake_animate}">
              <div class="input-group col-sm-12 mt5 birthday-date" style="padding: 0 0 0 0">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-default">預約日期</span>
                  </div>
                  <datepicker type="text" 
                      :input-class="{'form-control': true, 'is-invalid': !validate }" 
                        aria-label="Default" 
                        format="yyyy-MM-dd"
                        :language="zh"
                   :disabledDates="disabledDates"
                  aria-describedby="inputGroup-sizing-default" 
                           v-model="reservation_date"></datepicker>
              </div>
            </div>

            <div class="col-lg-6 center reservation-content">
              <ul>
                <li>預約費用為 NT 180 元整，您的車位將於預訂日期全天保留，當日您可無限進出場。</li>
                <li>每個會員帳號只能同時預約一格車位。</li>
                <li>入場後若地鎖未及時降下，您可點選「開啟地鎖」手動開啟。</li>
              </ul>
            </div>

            <transition name="fade" v-if="!loading">
              <div class="col-lg-12 center text-center">
                <button class="btn btn-pay btn-xl" v-on:click="dateNext()">下一步</button>
              </div>
            </transition>
          </div>


          <!-- 選擇車牌 -->
          <div v-if="mode == 'plate'" class="row">
            <div class="col-lg-12 text-center reservation-plate-text">
              請選擇您欲預約停車的車牌
            </div>
            <div class="col-lg-12 text-center reservation-plate-radio" v-for="plate in plates" :key="plate.id">
              <div class="form-check">
                <input class="form-check-input" type="radio" name="plate-radios" :value="plate.plate" :id="plate.plate" v-model="currentPlate">
                <label class="form-check-label" :for="plate.plate">
                  <div class="setting-plate text-center" :class="{'reservation-plate-active': currentPlate == plate.plate}">
                    {{ plate.plate }}
                  </div>  <!-- 選定車牌後，class 新增 reservation-plate-active -->
                </label>
              </div>
            </div>

            <div class="col-lg-6 center reservation-content">
              <ul>
                <li>預約費用為 NT 180 元整，您的車位將於預訂日期全天保留，當日您可無限進出場。</li>
                <li>每個會員帳號只能同時預約一格車位。</li>
                <li>入場後若地鎖未及時降下，您可點選「開啟地鎖」手動開啟。</li>
              </ul>
            </div>

            <transition name="fade" v-if="!loading">
              <div class="col-lg-8 center text-center">
                <button class="btn btn-pay btn-xl" v-on:click="plateNext()">下一步</button>
              </div>
            </transition>
          </div>
          <!-- 選擇車牌 -->

          <!-- 選擇預約車位 -->
          <div v-if="mode == 'grid'" class="row" >

            <transition name="fade" >
              <div class="reservation-highlight" v-if="!reserved && !loading">
                目前尚有 {{ empty_number }} 格車位可預約
              </div>
            </transition>
            <div class="reservation-box fl"
                 v-for="(grid, index) in grid_status" 
                  :key="grid.grid_index" 
            v-on:click="reserving(index)"
                :class="{ 'reserving' : grid.reserving, 'reserved': grid.reserved}"
                 :style="[reserved ? {'pointer-events':'none'}: {'pointer-events':'display'}]" >
              <div class="reservation-number" v-if="grid.grid_index == 1">
                2062-A
              </div>
              <div class="reservation-number" v-else>
                {{ grid.grid_index + 2060 }}
              </div>
              <transition  name="fade" mode="out-in">
              <div class="reservation-status" v-if="reserved && reserving_id == grid.grid_index">
                您的預訂
              </div>
              <div class="reservation-status" v-else-if="grid.reserved">
                已預訂
              </div>
              <div class="reservation-status" v-else>
                可預約
              </div>
              </transition>
              <div class="cb"></div>
            </div>

            <transition name="fade">
              <div class="col-lg-8 center text-center" v-if="!reserved && !loading">
                <button v-on:click="reservingButtonClick()" class="btn btn-pay btn-xl">確定預約</button>
              </div>
            </transition>

            <div class="col-lg-6 center reservation-content">
              <ul>
                <li>預約費用為 NT 180 元整，您的車位將於預訂日期全天保留，當日您可無限進出場。</li>
                <li>每個會員帳號只能同時預約一格車位。</li>
                <li>入場後若地鎖未及時降下，您可點選「開啟地鎖」手動開啟。</li>
              </ul>
            </div>

            <div class="lot-layout">
              <img src="img/liteon/parking_lot_layout.png" alt="" />
            </div>

            

            
            <!-- 選擇預約車位 -->

            <!-- reservation-error-modal -->
            <div class="reservation-modal modal fade" id="reservation-error-modal" tabindex="-1" role="dialog" aria-hidden="true">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="close-modal" data-dismiss="modal">
                    <div class="lr">
                      <div class="rl"></div>
                    </div>
                  </div>
                  <div class="container">
                    <div class="row">
                      <div class="col-lg-8 mx-auto">
                        <div class="modal-body">
                          <!-- Project Details Go Here -->
                          <h3 class="">預約失敗</h3>
                          <p class="item-intro text-muted">{{ errorMessage }}</p>
                          <button class="btn btn-primary btn-red" data-dismiss="modal" type="button">
                            確定
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div><!-- modal-content ends -->
              </div><!-- modal-dialog ends -->
            </div>
            <!-- reservation-error-modal ends -->

            <!-- reservation-success-modal -->
            <div class="reservation-modal modal fade" id="reservation-success-modal" tabindex="-2" role="dialog" aria-hidden="true">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="close-modal" data-dismiss="modal">
                    <div class="lr">
                      <div class="rl"></div>
                    </div>
                  </div>
                  <div class="container">
                    <div class="row">
                      <div class="col-lg-8 mx-auto">
                        <div class="modal-body">
                          <!-- Project Details Go Here -->
                          <h3 class="">預約成功</h3>
                          <p class="item-intro text-muted">您的預約停車已成功，請於 LINE 上查看您的預約狀態。</p>
                          <div class="lot-layout"><img src="img/liteon/parking_lot_layout.png" alt="" /></div>
                          <button class="btn btn-primary btn-green" data-dismiss="modal" type="button">
                            確定
                          </button>


                        </div><!-- modal-body ends -->
                      </div><!-- col-lg-8 mx-auto ends -->
                    </div><!-- row ends -->
                  </div><!-- container ends -->
                </div><!-- modal-content ends -->
              </div><!-- modal-dialog ends -->
            </div>
            <!-- reservation-success-modal ends -->
          
          </div>

        </div><!--container ends-->
      </section>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {zh} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'

export default {
  name: 'ReservationView',
  components: {
    Datepicker
  },
  props: {
  },
  data() {
    var currentDate =  moment(new Date()).subtract(1, 'days').endOf('day').toDate()

    return {
      grid_status: [],
      empty_number: 0,
      loading: false,
      reserving_id: -1,
      reserved: false,
      user_status: {},
      plates: [],
      select_plate_index: -1,
      currentPlate: "",
      mode: "plate",
      reservation_date: "",
      shake_animate: false,
      validate: true,
      zh: zh,
      errorMessage: "您的預約停車失敗，可能是網路不穩定，請您稍後再試。",
      disabledDates: {
        to: currentDate
      }
    }
  },
  mounted() {
    var self = this;
    self.loading = true
    self.getPlate()
  },
  methods: {
    plateNext: function() {
      var self = this
      if (self.currentPlate) {
        self.mode = "date"
      }
    },
    dateNext: function() {
      var self = this
      if (self.reservation_date) {
        self.validate = true
        self.getReserving()
      } else {
        self.shake_animate = true
        setTimeout(function(){ self.shake_animate = false; }, 1000)
        self.validate = false
      }
    },
    reserving: function(index) {
      var self = this
      if (!self.grid_status[index].reserved && !self.reserved) {
        for (var i = 0; i < self.grid_status.length; i ++) {
          self.grid_status[i].reserving = false
        }

        self.grid_status[index].reserving = true
        self.reserving_id = self.grid_status[index].grid_index
      }
    },
    reservingButtonClick: function() {
      var self = this
      self.loading = true
      if (self.reserving_id !== -1) {
        self.$http.post('https://'+ process.env.VUE_APP_API_URL +'/reservation?access_token=' + self.$cookie.get('access_token'), {
          plate: self.currentPlate,
          lot_code: "086BDF5709AE",
          grid_id: self.reserving_id,
          reservation_date: moment(self.reservation_date).format("YYYY-MM-DD 00:00:00")
        }).then(function(response) {
          if (response.body.status == "success") {
            self.reserved = true
            self.loading = true
            //$("#reservation-success-modal").modal("show")
            window.location.replace("https://" + process.env.VUE_APP_API_URL + "/payment/line?plate=" + self.currentPlate + "&parking_record_id=" + response.body.parking_record_id + "&access_token=" + self.$cookie.get('access_token') + "&brand=" + process.env.VUE_APP_BRAND);
          } else {
            self.loading = false
            self.errorMessage = "您的預約停車失敗，可能是網路不穩定，請您稍後再試。"
            $("#reservation-error-modal").modal("show")
          }
        }).catch(function(response) {
          self.loading = false
          self.errorMessage = "您的預約停車失敗，可能是網路不穩定，請您稍後再試。"
          $("#reservation-error-modal").modal("show")
        })
      } else {
        self.loading = false
        self.errorMessage = "您的未選取預約車格，請您點選後再試一次。"
        $("#reservation-error-modal").modal("show")
      }
    },
    getReserving: function() {
      var self = this
      self.loading = true
      self.$http.get('https://' + process.env.VUE_APP_API_URL + '/reservation?lot_code=086BDF5709AE&reservation_date=' + moment(self.reservation_date).format("YYYY-MM-DD 00:00:00"))
        .then((response) => {
          self.grid_status = response.body.result.grid_status
          self.empty_number = response.body.result.empty_grid
          self.$http.get('https://' + process.env.VUE_APP_API_URL + '/reservation/user?lot_code=086BDF5709AE&&reservation_date=' + moment(self.reservation_date).format("YYYY-MM-DD 00:00:00") +'&access_token=' + self.$cookie.get('access_token'))
            .then((response) => {
              self.user_status = response.body
              if (self.user_status.id) {
                self.reserved = true
                self.reserving_id = self.user_status.grid_number
                for (var i = 0; i < self.grid_status.length; i ++) {
                  if (self.grid_status[i].grid_index === self.reserving_id) {
                    self.grid_status[i].reserving = true
                    self.grid_status[i].reserved = false
                  }
                }
              }
              self.mode = "grid"
              self.loading = false
            })
        })
    },
    getPlate: function() {
      var self = this
      self.$http.get('https://' + process.env.VUE_APP_API_URL + '/license_plates?disable_special=true&access_token=' + self.$cookie.get('access_token'))
      .then((response) => {
        self.plates = response.body
        self.loading = false
        if (self.plates.length > 0)
          self.currentPlate = self.plates[0].plate
      })
    }
  }
}
</script>